import { injectable } from "inversify";
import { action, makeObservable, observable } from "mobx";
import RouteService, { RouteType } from "@/src/application/services/route-service";

@injectable()
export default class RouteServiceImpl extends RouteService {
  @observable
  private _currentRouteType: RouteType = RouteType.PUBLIC;

  constructor() {
    super();
    makeObservable(this);
  }

  get currentRouteType(): RouteType {
    return this._currentRouteType;
  }

  @action
  setRouteType(routeType: RouteType): void {
    this._currentRouteType = routeType;
  }

  get isPrivateRoute(): boolean {
    return this._currentRouteType === RouteType.PRIVATE;
  }

  get isPublicRoute(): boolean {
    return this._currentRouteType === RouteType.PUBLIC;
  }
}
